<template>
    <sa-page-layout :btnNewVisible="false" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkback="linkback" :showModalLoading="false">
        <template slot="toolbar">
            <b-button :hidden="!btnSalvaProgrammazioneVidible" variant="success btn-toolbar sa-margin-left float-sm-left" @click="onClickSalvaProgrammazione">
                <b-icon icon="file-earmark-plus" aria-hidden="true"></b-icon>
                Salva Programmazione
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit" :key="formKey">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Cognome:</label>
                        <b-form-input v-model="filtroGestionePazientiAdi.cognome" id="cognome" placeholder="Cognome"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Nome:</label>
                        <b-form-input v-model="filtroGestionePazientiAdi.nome" id="nome" placeholder="Nome"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Identificativo:</label>
                        <b-form-input v-model="filtroGestionePazientiAdi.identificativo" id="identificativo" :placeholder="this.$i18n.t('adi.lblFiscalCode')"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Presidio:</label>
                        <b-form-select v-model="filtroGestionePazientiAdi.idPresidio" :options="presidiOptions" :value="null" value-field="idPresidio" text-field="denominazionePresidio" :disabled="true"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data Riferimento</label>
                        <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="filtroGestionePazientiAdi.dataRiferimento" type="date"></date-picker>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-gestione-pazienti-adi-component ref="cmpRsaGestionePazientiAdi" @tabChange="onTabChange"></rsa-gestione-pazienti-adi-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
//import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import RsaGestionePazientiAdiComponent from "../components/RsaGestionePazientiAdiComponent.vue";
export default {
    name: "RsaGestioneOspitiListPage",
    components: { SaPageLayout, DatePicker, RsaGestionePazientiAdiComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            filtroGestionePazientiAdi: { nome: null, cognome: null, identificativo: null, idPresidio: null, dataRiferimento: new Date().getTime() },
            btnNewVisible: true,
            btnBackVisible: true,
            linkback: "/home",
            pathResource: "/ospiti",
            pathResourceUtentiPresidi: "/utentipresidi",
            pathResourceSettingsPresidi: "/rsasettingspresidi",
            showModalLoading: false,
            listKey: 0,
            presidiOptions: [],
            formKey: 0,
            btnSalvaProgrammazioneVidible: true,
        };
    },
    mounted() {
        let me = this;
        me.loadUtentiPresidi();
    },
    methods: {
        setIdPresidio() {
            let me = this;
            // console.log(localStorage.getItem("presidio"));

            if (localStorage.getItem("presidio")) {
                let presidio = localStorage.getItem("presidio") == "null" ? null : JSON.parse(localStorage.getItem("presidio"));
                me.filtroGestionePazientiAdi.idPresidio = presidio !== null ? presidio.idPresidio : null;
                this.formKey++;
            }
        },
        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroGestionePazientiAdi"]) {
                me.filtroGestionePazientiAdi = JSON.parse(sessionStorage["filtroGestionePazientiAdi"]);
            } else {
                me.filtroGestionePazientiAdi = { nome: null, cognome: null, identificativo: null, idPresidio: null, dataRiferimento: new Date().getTime() };
            }
            this.setIdPresidio();
            me.$refs.cmpRsaGestionePazientiAdi.init(me.filtroGestionePazientiAdi);
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onReset() {
            let me = this;
            this.filtroGestionePazientiAdi.nome = null;
            this.filtroGestionePazientiAdi.cognome = null;
            this.filtroGestionePazientiAdi.identificativo = null;
            this.filtroGestionePazientiAdi.idPresidio = null;
            this.filtroGestionePazientiAdi.dataRiferimento = new Date().getTime();
            this.setIdPresidio();
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroGestionePazientiAdi"] = JSON.stringify(this.filtroGestionePazientiAdi);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroGestionePazientiAdi"] = JSON.stringify(me.filtroGestionePazientiAdi);
            me.loadData();
        },
        loadUtentiPresidi() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceUtentiPresidi, { idUtente: this.user.id }, me.resulResponseUtentiPresidi, me.resulErrorUtentiPresidi);
        },
        resulResponseUtentiPresidi(response) {
            let me = this;
            me.presidiOptions = [];
            me.presidiOptions = response.data.data.list;
            me.presidiOptions.unshift({ denominazionePresidio: "- Tutti i presidi -", idPresidio: null });
            me.loadData();
        },
        resulErrorUtentiPresidi(error) {
            console.log(error);
        },
        onChangePresidio() {},
        onClickSalvaProgrammazione() {
            this.$refs.cmpRsaGestionePazientiAdi.salvaProgrammazione();
        },
        onTabChange(tabIndex) {
            if (tabIndex == 0) {
                this.btnSalvaProgrammazioneVidible = true;
            } else {
                this.btnSalvaProgrammazioneVidible = false;
            }
        },
    },
};
</script>

<style></style>
